import { buildPurpleTranslations } from "@purple-lib/purple-translations-core";

export const PurpleFitCoreTranslations = buildPurpleTranslations(
    "it-it",
    {
        REGISTER: {
            page_title: "Registrati",
            page_subtitle: "Compila i campi e crea il tuo account.",
            page_register_step_2_button: "Registrati",
            page_desktop_form_title: "Registrati",
            register_page_form_password_info: "La password deve contenere almeno 8 caratteri, una lettera maiuscola e un carattere speciale (,;.!@#$%^&*)"
        },
        AUTH_PAGE: {
            purple_fit_name: "Möt studios",
            promo_disclaimer: "Inizia le tue prime lezioni a meno di 30€."
        },
        LOGIN: {
            page_title: "Accedi",
            page_subtitle: "Continua con Google o Apple oppure accedi.",
            page_forgot_password: "Password dimenticata?",
            page_login_button: "Login",
            page_other_login: "O",
            page_desktop_form_title: "Accedi o crea un nuovo account",
            page_desktop_form_subtitle: "Continua con Google o Apple oppure accedi.",
            page_selected_company: "Palestra selezionata:"
        },
        MY_PURPLE_FIT: {
            change_company: "Cambia palestra",
            change_dafult_language: "Lingua",
            logout: "Logout",
            personal_info_title: "Profilo",
            personal_info_button: "Salva",
            change_language: "Cambia lingua notifiche",
            my_account: "Il mio Account",
            statistics_title: "Statistiche ",
            my_bookings_title: "Prenotazioni",
            packages_title: "Acquisti ",
            packages_book_button_text: "Prenota",
            edit_personal_info_missing_info_modal_title: "Informazioni mancanti",
            edit_personal_info_missing_info_modal_message: "Completa le informazioni mancanti per poter salvare le modifiche al profilo",
        },
        REQUEST_RESET_PASSWORD: {
            page_title: "Reset Password",
            page_subtitle: "Richiedi il reset della password.",
            page_reset: "Reset Password",
            page_desktop_form_title: "Reset Password"
        },
        RESET_PASSWORD: {
            page_title: "Completa Reset Password",
            page_subtitle: "Reimposta la password.",
            page_reset: "Reimposta Password",
            page_desktop_form_title: "Completa Reset Password"
        },
        ACTION: {
            class_drawer_add_to_calendar: "Aggiungi al calendario",
            class_drawer_unbook_class: "Cancella prenotazione"
        },
        MY_PURPLE_FIT_STATS: {
            total_classes: "Classi effettuate",
            training_hours: "Ore allenament.",
            credit_left: "Crediti rimasti",
            next_class: "Prossima Classe"
        },
        MY_PURPLE_FIT_MENU: {
            account_my_statistics: "Statistiche"
        },
        PURPLE_FIT_TRAINER: {
            home_total_classes: "Classi",
            home_total_done_classes: "Classi totali tenute",
            home_occupancy_rate: "Occupazione",
            home_book_class_button: "Nessuna classe",
            home_book_class_next_class_intro_button: "La tua prossima classe",
            home_prebooking_alert_title: "Prenotazioni dell'ultimo minuto",
            home_prebooking_alert_subtitle: "Prenotazioni in attesa di conferma",
            home_daily_schedule_title: "Il tuo programma giornaliero",
            home_month_stats_title: "Stato mensile",
            home_month_workout_stats_title: "Discipline",
            home_workout_class_stats_title: "Classi",
            home_workout_class_monthly_occupancy_title: "Occupazione mensile",
            home_no_workout_class_stats: "Nessuna statistica disponibile"
        },
        PURPLE_FIT_TRAINER_PROFILE: {
            home_occupancy_rate: "Occupazione totale"
        },
        CLASS_CALENDAR_FILTER_MODAL: {
            time_range: "Orario",
            workouts: "Discipline",
            class_level: "Livelli Classe",
            class_trainers: "Istruttori",
            reset_filter_button: "Pulisci filtri",
            filter_button: "Mostra {0} risultati"
        },
        CLASS_CALENDAR_FILTER_DRAWER: {
            time_range: "Orario",
            workouts: "Discipline",
            class_level: "Livelli Classe",
            class_trainers: "Istruttori",
            reset_filter_button: "Pulisci filtri"
        },
        BOOK: {
            class_modal_class_info: "Informazioni classe",
            class_modal_date_title: "Data",
            class_modal_duration_title: "Durata",
            class_modal_location_title: "Location",
            class_modal_level_title: "Livello",
            class_modal_friends_title: "Amici iscritti alla classe",
            class_drawer_no_friends: "Nessun amico",
            class_drawer_trainer_with: "Con",
            class_drawer_class_info: "Informazioni classe",
            class_drawer_date_title: "Data",
            class_drawer_duration_title: "Durata",
            class_drawer_location_title: "Location",
            class_drawer_level_title: "Livello",
            class_drawer_friends: "Amici iscritti alla classe"
        },
        CALENDAR: {
            time_mins: "min",
            class_popover_rejected: "Rifiutata",
            class_popover_general_info_preview: "Informazioni generali:",
            class_typology: "Tipologia",
            class_popover_all_roles: "Tutti i ruoli",
            class_popover_illimited_number: "Posti illimitati",
            class_popover_pre_booking_slot_number: "Utenti in attesa",
            class_popover_booked_slot_number: "Posti prenotati",
            class_popover_free_slot_number: "Posti liberi",
            class_button_rejected: "Rifiutato"
        },
        CLASS: {
            booked_users_drawer_friends: "Partecipanti",
            booked_users_drawer_class_info: "Informazioni classe",
            booked_users_drawer_date_title: "Data",
            booked_users_drawer_duration_title: "Durata",
            booked_users_drawer_location_title: "Location",
            booked_users_drawer_level_title: "Livello",
            booked_users_drawer_no_bookings: "Nessun iscritto alla classe",
            details: "Dettagli classe",
            type: "Tipologia classi"
        },
        ATTENTION: {
            attention: "ATTENZIONE"
        },
        REJECT: {
            prebooking_warning: "Rifiutando annullerai questa lezione e tutti i partecipanti verranno notificati."
        },
        CONFIRM: {
            pre_booking_class_modal_reject: "Rifiuta",
            pre_booking_class_modal_accept: "Accetta",
            book_class_modal_discard: "Annulla"
        },
        TRAINER: {
            schedule_subtitle: "Calendario degli allenamenti"
        },
        CLASS_CALENDAR: {
            filter_button: "Filtri",
            subtitle: "Seleziona la location per la tua prossima classe",
            table_friends_column: "Amici"
        },
        ADDTOCALENDAR: {
            addtocalendar: "Aggiungi al calendario"
        },
        USERS: {
            users: "Utenti:"
        },
        PURPLE: {
            fit_home_welcome_title: "Benvenuto, {0}",
            fit_home_warning_title: "Avvisi",
            fit_home_title: "Ciao, {0}",
            fit_home_workouts_title: "Statistiche discipline",
            fit_home_month_stats_title: "Stato mensile",
            fit_home_daily_schedule_title: "Attività giornaliere",
            fit_home_book_class_button: "Prenota classe",
            fit_home_book_class_subtitle_button: "Inizia ad allenarti!",
            fit_home_book_class_next_class_intro_button: "La tua prossima prenotazione",
            fit_home_total_classes: "Crediti totali",
            fit_home_training_hours: "Ore allenamento",
            fit_home_products_title: "Pacchetti più popolari",
            fit_home_show_more_button: "Mostra di più",
            fit_home_products_empty: "Nessun prodotto disponibile"
        },
        CLAS: {
            calendar_empty_title: "Calendario"
        },
        UNBOOK: {
            class_modal_yes_button: "Sì",
            class_modal_no_button: "No",
            class_modal_title: "Sei sicuro di voler cancellare questa classe?"
        },
        PRODUCT: {
            buy_drawer_info_section: "Altre informazioni",
            buy_modal_info_promo_code: "Codice promozionale",
            buy_modal_apply_promo_code_button: "Applica",
            buy_button: "Compra (€{0})"
        },
        VALIDATION: {
            hours: "Orari validità:"
        },
        WORKOUT: {
            categories: "Categoria Allenamento"
        },
        COMPLETED: {
            class: "Completata"
        },
        PROMO: {
            code_apply_button: "Applica",
            code_remove_button: "Rimuovi"
        },
        BUY: {
            product_drawer_promo_code: "Codice promozionale"
        },
        PRODUCTS: {
            buy_credits: "Acquista Crediti",
            title: "Ricarica i tuoi crediti classe",
            subtitle: "Acquista un pacchetto di classi e inizia a muoverti.",
            buy_button: "Compra"
        },
        INTRO: {
            offer_badge: "Offerta introduttiva"
        },
        register_page_form_firstname: "Nome",
        register_page_form_lastname: "Cognome",
        register_page_form_email: "Email",
        invalid_email_validator_error_text: "Email non valida",
        register_page_form_birthdate: "Data di nascita",
        register_page_form_gender: "Sesso",
        register_page_form_gender_man: "Uomo",
        register_page_form_gender_female: "Donna",
        register_page_form_other: "Altro",
        register_page_form_vatid: "Codice Fiscale",
        register_page_form_address: "Indirizzo",
        register_page_form_phone: "Telefono",
        register_page_form_phone_prefix_placeholder: "Pref.",
        register_page_form_injuries: "Infortuni",
        register_page_form_promo_code: "Codice Promozionale",
        register_page_register_step_1_button: "Avanti",
        register_page_desktop_step_1_form_subtitle: "Compila i campi e crea il tuo account.",
        register_page_register_step_2_button: "Registrati",
        register_page_desktop_step_2_form_subtitle: "Compila i campi e crea il tuo account.",
        login_page_form_email: "Email",
        login_page_form_password: "Password",
        social_login_error_title: "Ops! qualcosa è andato storto",
        social_login_error_message: "Si è verificato un errore durante il login con il social",
        social_login_error_button: "Chiudi",
        register_page_form_password: "Password",
        register_page_form_check_password: "Conferma password",
        invalid_email_match_validator_error_text: "Le password inserite non corrispondono",
        register_ok_title: "Registrazione completata",
        register_ok_subtitle: "Ricordati di verificare l'indirizzo email per poter accedere",
        register_ok_button: "Ok",
        reset_password_check_reset_id_modal_button: "Conferma",
        reset_password_check_reset_id_title_ko: "Errore",
        reset_password_check_reset_id_subtitle_ko: "Link di reset password non valido",
        reset_password_page_form_email: "Email",
        reset_password_page_form_password: "Password",
        reset_password_page_form_new_password: "Conferma Password",
        menu_public_login: "Accedi",
        change_company_modal_title: "Sei sicuro di voler cambiare Palestra?",
        change_company_modal_message: "Cambiare Palestra ti disconnetterà e ti porterà alla schermata di inserimento pin per selezionare una nuova Palestra oppure sarà necessario scannerizzare il QR code.",
        change_company_modal_button: "Conferma",
        change_company_modal_cancel_button: "Annulla",
        menu_public_register: "Registrati",
        menu_private_home: "Homepage",
        menu_private_schedule: "Schedule",
        menu_private_class_calendar: "Prenota Classe",
        menu_private_class_products: "Acquista Crediti",
        menu_private_my_purple_fit: "Profilo",
        menu_private_class_my_purple_fit: "Profilo",
        menu_tab_private_home: "Homepage",
        menu_tab_private_class_calendar: "Calendario",
        menu_tab_private_my_bookings: "Prenotazioni",
        menu_tab_private_my_wallet: "Wallet",
        menu_tab_private_class_products: "Crediti",
        my_purple_fit_logout_title: "Logout",
        my_purple_fit_logout_message: "{0} sei sicuro di voler uscire?",
        my_purple_fit_logout_ok_button: "Conferma",
        my_purple_fit_logout_error_title: "Qualcosa è andato storto",
        my_purple_fit_logout_error_subtitle: "Impossibile effettuare il logout",
        my_purple_fit_logout_error_button: "Ok",
        my_purple_fit_tab_account_personal_info: "Profilo",
        my_purple_fit_tab_account_my_bookings: "Prenotazioni",
        my_purple_fit_tab_my_purple_fit_credits: "Acquisti",
        my_purple_fit_tab_account_statistics: "Statistiche",
        my_purple_fit_logout: "Logout",
        my_purple_fit_location_closures: "Chiusure location",
        my_purple_fit_change_location: "Cambia palestra",
        unbook_class_drawer_title: "Sei sicuro di voler cancellare questa classe?",
        my_purple_fit_title: "Il mio profilo",
        my_purple_fit_menu_account: "Account",
        my_purple_fit_menu_account_personal_info: "Informazioni personali",
        my_purple_fit_menu_account_my_statistics: "Le mie statistiche",
        my_purple_fit_personl_info_title: "Profilo",
        my_purple_fit_location_closures_title: "Chiusure location",
        my_purple_fit_personal_info_no_saved_changes_title: "Modifiche non salvate",
        my_purple_fit_personal_info_no_saved_changes_message: "Salvare le modifiche effettuate?",
        my_purple_fit_personal_info_no_saved_changes_button: "Salva",
        my_purple_fit_personal_info_no_saved_changes_button_cancel: "Annulla",
        my_purple_fit_no_changes_title: "Nessuna modifica",
        my_purple_fit_no_changes_message: "Non è stata effettuata alcuna modifica",
        my_purple_fit_no_changes_button: "Ok",
        accept_reject_pre_booking_error_title: "Qualcosa è andato storto",
        accept_reject_pre_booking_error_button: "Riprova",
        my_purple_fit_personal_info_upload_image_ko_title: "Errore",
        my_purple_fit_personal_info_upload_image_ko_description: "Non è stato possibile aggiornare la foto profilo",
        my_purple_fit_personal_info_upload_image_ok_button: "Ok",
        my_purple_fit_personal_info_upload_image_ok_title: "Immagine aggiornata",
        my_purple_fit_personal_info_upload_image_ok_description: "Foto profilo aggiornata con successo",
        my_purple_fit_change_company_title: "Cambia Palestra",
        my_purple_fit_change_company_message: "{0} sei sicuro di voler cambiare palestra?",
        my_purple_fit_change_company_ok_button: "Conferma",
        my_purple_fit_change_company_error_title: "Qualcosa è andato storto",
        my_purple_fit_change_company_error_subtitle: "Impossibile effettuare il cambio",
        my_purple_fit_change_company_error_button: "Ok",
        booking_type_title_active: "Confermati",
        booking_type_title_waiting: "In attesa",
        booking_type_title_prebooking: "Da confermare",
        accept_reject_pre_booking_confirm_accepted_title: "Prenotazione confermata",
        accept_reject_pre_booking_confirm_reject_title: "Prenotazione rifiutata",
        accept_reject_pre_booking_confirm_accepted_subtitle: "La classe {0} delle ore {1} del {2} è stata confermata",
        accept_reject_pre_booking_confirm_reject_subtitle: "La classe {0} delle ore {1} del {2} è stata annullata",
        accept_reject_pre_booking_confrim_button: "Ok",
        error_pre_booking_error_title: "Qualcosa è andato storto",
        error_pre_booking_error_subtitle: "Prenotazione non trovata",
        error_pre_booking_error_button: "Chiudi",
        trainer_schedule_calendar_title: "Calendario",
        accept_reject_modal_title: "Nuova richiesta di prenotazione",
        calendar_class_filter_drawer_title: "Filtri",
        calendar_class_filter_modal_title: "Filtri",
        trainer_schedule_class_status_past_done: "Terminata",
        trainer_schedule_class_status_past_cancel: "Cancellata",
        trainer_schedule_class_status_empty: "Vuota",
        trainer_schedule_class_status_pre_booking: "Da Confermare",
        trainer_schedule_class_status_next_confirmed: "Confermata",
        calendar_class_button_free: "Prenota",
            calendar_class_button_waiting_booked: "In attesa",
            calendar_class_button_waiting_spot_available: "Prenota",
        calendar_class_button_booked: "Prenotato",
        class_calendar_calendar_title: "Prenota Classe",
        class_calendar_locations_title: "Location",
        class_calendar_reopen_after_buy_prod_ko_title: "Attenzione",
        class_calendar_reopen_after_buy_prod_ko_message: "La classe che si voleva prenotare è piena",
        request_reset_password_modal_button: "Conferma",
        select_location_drawer: "Seleziona la location",
        select_location_modal: "Seleziona la location",
        book_class_modal_teacher_with: "con {0}",
        book_class_drawer_buy_credits_button: "Compra crediti",
        book_class_drawer_free_button: "Prenota",
        book_class_drawer_waiting_button: "Lista di attesa",
        book_class_drawer_waiting_booked_button: "Prenota",
        minutes_label: "{0} minuti",
        hours_label: "{0} ore",
        book_class_error_modal_title_free: "Errore Prenotazione",
        book_class_error_modal_title_waiting: "Errore Prenotazione",
        book_class_confirm_modal_button: "Conferma",
        book_class_confirm_modal_title_free: "Conferma prenotazione",
        book_class_confirm_modal_title_waiting: "Conferma prenotazione",
        book_class_confirm_modal_message_message_free: "La prenotazione è stata effettuata con successo!",
        book_class_confirm_modal_message_message_waiting: "La prenotazione è stata effettuata con successo!",
        unbook_class_error_mobile_title: "Errore cancellazione",
        bunook_class_confirm_mobile_button: "Conferma",
        unbook_class_confirm_modal_title: "Conferma cancellazione",
        bunook_class_confirm_modal_button: "Conferma",
        unbook_class_confirm_modal_message_message: "La prenotazione è stata cancellata con successo!",
        product_expire_in_days: "Scadenza {0} giorni",
        product_validity_days: "Giorni",
        product_closing_days: "di chiusura",
        product_expire_in_weeks: "Scadenza {0} settimane",
        product_expire_in_months: "Scadenza {0} mesi",
        product_class_credit: "{0} Credito",
        product_class_credits: "{0} Crediti",
        my_purple_fit_my_bookings_title_header: "Prenotazioni",
        actions_class_drawer_title: "Azioni",
        unbook_class_modal_title: "Sei sicuro di voler cancellare questa classe?",
        booking_type_active: "Confermata",
        booking_type_completed: "Completata",
            booking_type_waiting_mobile: "In attesa",
        booking_type_waiting: "Lista d'attesa",
        my_purple_fit_menu_account_my_bookings: "Le mie prenotazioni",
        my_purple_fit_menu_account_billing_payment: "Acquisti",
        my_purple_fit_menu_my_purple_fit: "Il mio profilo",
        my_purple_fit_menu_my_purple_fit_statistics: "Statistiche",
        my_purple_fit_menu_my_purple_fit_friends: "Amici",
        my_purple_fit_packages_title_header: "Crediti",
        my_purple_fit_packages_empty_list_button: "Compra Crediti",
        all_locations: "Tutte le location",
        my_purple_fit_packages_credit_expired: "Scaduto",
        my_purple_fit_packages_credit_ended: "Esauriti",
        my_purple_fit_packages_available_credit: "{0} Rimasto",
        my_purple_fit_packages_available_credits: "{0} Rimasti",
        bought_product_detail_drawer_title: "Pacchetto Acquistato",
        bought_product_detail_modal_title: "Pacchetto Acquistato",
        buy_product_promo_code_dirty_title: "Codice promozionale",
        buy_product_promo_code_dirty_subtitle: "Vuoi applicare il codice promozionale prima di procedere all'acquisto?",
        buy_product_promo_code_dirty_button: "Applica",
        buy_product_promo_code_skip_button: "Salta",
        verify_coupon_error_title: "Coupon non valido",
        verify_coupon_error_button: "Ok",
        products_title_header: "Crediti",
        product_proceed_button: "Procedi",
        buy_product_confirm_drawer_message_message: "L'acquisto è stato effettuato con successo!",
        buy_product_error_drawer_message_message: "Non è stato possibile completare l'acquisto!",
        buy_product_confirm_modal_button: "Prenota la tua lezione",
        buy_product_error_modal_button: "Riprova",
        buy_product_confirm_modal_title: "Conferma pagamento",
        buy_product_error_modal_title: "Errore pagamento",
        buy_product_confirm_drawer_title: "Conferma pagamento",
        buy_product_error_drawer_title: "Errore pagamento",
        buy_product_drawer_title: "Dettaglio Pacchetto",
        buy_product_modal_title: "Dettaglio Pacchetto",
        purple_fit_home_buy_credits_button: "Compra crediti",
        purple_fit_home_book_class_button: "Prenota classe",
        purple_fit_home_credit: "{0} credito",
        purple_fit_home_credits: "{0} crediti",
        purple_fit_home_no_credits: "Compra crediti",
        product_class_credit_qty: "{0} Classe",
        product_class_credits_qty: "{0} Classi"
        ,
        login_page_register_disclaim: "Non hai un account? <a href='{0}'>Registrati</a>",
        register_page_login_disclaim: "Hai già un account? <a href='{0}'>Accedi</a>",
        login_page_login_with_google: "Accedi con Google",
        login_page_login_with_apple: "Accedi con Apple",
        login_page_other_login: "O",
        request_reset_password_page_login_disclaim: "Ricordi la password? <a href='{0}'>Accedi qui</a>",
        reset_password_page_login_disclaim: "Ricordi la password? <a href='{0}'>Accedi qui</a>",
        calendar_time_mins: "min",
        my_purple_fit_personal_info_save_button: "Salva",
        class_booked_users_drawer_date_title: "Data",
        class_booked_users_drawer_duration_title: "Durata",
        class_booked_users_drawer_location_title: "Location",
        class_booked_users_drawer_level_title: "Livello",
        tab_mySchedule: "PROGRAMMA",
        trainer_schedule_table_time_column: "Ora",
        trainer_schedule_table_class_column: "Classe ",
        trainer_schedule_table_level_column: "Livello",
        trainer_schedule_table_booked_column: "Prenotati",
        book_class_drawer_location_title: "Location",
        calendar_class_popover_waiting_slot_number: "{0} in waiting",
        calendar_class_popover_actions: "Azioni:",
        purple_fit_trainer_home_book_class_subtitle_button: "Non hai in programma altre classi!",
        purple_fit_trainer_home_workout_class_stats: "{0} classi su {1} completate questo mese",
        purple_fit_trainer_home_workout_class_stats_title: "Classi",
            class_calendar_subtitle: "Seleziona la location per la tua prossima classe",
            class_calendar_subtitle_calendar: "Scegli una data e una fascia oraria",
            book_class_drawer_remaining_credits: "{0} crediti rimanenti",
        product_buy_modal_info_section_info_price: "Prezzo",
        product_buy_modal_info_section_info_paid_price: "Prezzo pagato",
        product_buy_modal_info_section_info_original_price: "Prezzo originale",
        product_buy_modal_info_section_info_offer_price: "Prezzo in offerta",
        product_buy_modal_info_section_info_final_price: "Prezzo finale",

        product_buy_modal_info_section_info_coupon_discount_amount: "Sconto coupon",
        product_buy_modal_info_section_info_location: "Location",
        product_buy_modal_info_section_info_name: "Nome prodotto",
        product_buy_modal_info_section_info_description: "Descrizione",
        product_buy_modal_info_section_info_package: "Pacchetto",
        product_buy_modal_info_section_info_classes_qty: "Crediti",
        product_buy_modal_info_section_info_type: "Tipo prodotto",
        product_buy_modal_info_section_info_type_desc: "Descrizione tipo",
        product_buy_modal_info_section_info_role: "Ruolo",
        product_buy_modal_info_section_info_role_desc: "Descrizione ruolo",
        included: "inclusi",
        product_buy_modal_info_section_info_expire_date: "Scadenza",
        product_buy_modal_info_section_info_location_desc: "Descrizione location",
        product_buy_drawer_info_section_name: "Nome prodotto",
        product_buy_drawer_info_section_description: "Descrizione",
        product_buy_drawer_info_section_type: "Tipo prodotto",
        product_buy_drawer_info_section_type_desc: "Descrizione tipo",
        product_buy_drawer_info_section_role: "Ruolo",
        product_buy_drawer_info_section_role_desc: "Descrizione ruolo",
        my_purple_fit_bookings_table_date_column: "Ora",
        my_purple_fit_bookings_table_class_column: "Classe ",
        my_purple_fit_bookings_table_level_column: "Livello",
        class_calendar_table_location_column: "Location",
        class_calendar_table_status_column: "Stato",
        my_purple_fit_packages_buy_on: "Acquisto: {0}",
        my_purple_fit_packages_expire_on: "Scadenza: {0}",
        my_purple_fit_packages_table_package_column: "Pacchetto",
        my_purple_fit_packages_table_expire_type_column: "Tipologia ",
        my_purple_fit_packages_table_price_column: "Prezzo",
        my_purple_fit_packages_table_location_column: "Location",
        my_purple_fit_packages_table_purchase_date_column: "Data acquisto",
        my_purple_fit_packages_table_expire_date_column: "Data scadenza",
        my_purple_fit_packages_table_payment_type_column: "Tipologia pagamento",
        my_purple_fit_packages_table_status_column: "Stato",
        purple_fit_home_month_stats_empty: "Inizia ad allenarti oggi e monitora i tuoi progressi qui!",
        purple_fit_home_book_class_next_class_intro_button: "La tua prossima prenotazione"
        ,
        login_page_remember_me: "Ricordami",
        request_reset_password_page_desktop_form_subtitle: "Richiedi il reset della password.",
        reset_password_page_desktop_form_subtitle: "Reimposta la password.",
        class_booked_users_drawer_no_bookings: "Nessun iscritto alla classe",
        calendar_class_popover_general_roles_preview: "Prenotazioni:",
        calendar_class_popover_max_slot_capacity: "Capacità massima",
            purple_fit_trainer_home_month_stats_empty: "Inizia ad allenarti oggi e monitora i tuoi progressi qui!",
        purple_fit_trainer_home_workout_class_occupancy_title: "Occupazione",
        purple_fit_trainer_home_workout_occupancy_stats: "{0}% è il tasso di occupazione mensile",
        purple_fit_trainer_home_prebooking_alert_subtitle: "Prenotazioni in attesa di conferma",
        purple_fit_trainer_home_prebooking_no_alert_subtitle: "Nessun avviso",
        class_calendar_table_time_column: "Ora",
        class_calendar_table_class_column: "Classe ",
        class_calendar_table_level_column: "Livello",
        book_class_drawer_date_title: "Data",
        book_class_drawer_duration_title: "Durata",
        book_class_drawer_level_title: "Livello",
        book_class_modal_date_title: "Data",
        book_class_modal_duration_title: "Durtata",
        book_class_modal_level_title: "Livello",
        my_purple_fit_my_bookings_title: "Prenotazioni",
        my_purple_fit_packages_title: "Acquisti ",
        buy_products_info: "Un credito è un token unico che consente di iscriversi a una classe all'interno di un corso specifico.",
        my_purple_fit_closures_title: "Date di Chiusura",
        my_purple_fit_closures_status_closed: "Chiuso",
        my_purple_fit_closures_empty_list_text: "Nessuna chiusura pianificata trovata.",
        my_purple_fit_closures_table_location_column: "Location",
        my_purple_fit_closures_table_start_date_column: "Data Inizio",
        my_purple_fit_closures_table_end_date_column: "Data Fine",
        my_purple_fit_closures_table_description_column: "Descrizione / Motivo",
        my_purple_fit_closures_table_status_column: "Stato",
    }
);
